module.exports = __webpack_public_path__ + "img/under-review-2.226e1cc1.png";